export default "__VITE_ASSET__CNFPpUc9__"